function getFirstDayOfPreviousMonths(monthsAgo: number): string {
  const now = new Date();
  const previousMonth = new Date(now.getFullYear(), now.getMonth() - monthsAgo, 1);

  const year = previousMonth.getFullYear();
  const month = previousMonth.getMonth() + 1;

  const formattedMonth = month < 10 ? `0${month}` : `${month}`;

  return `${year}-${formattedMonth}-01`;
}

export default getFirstDayOfPreviousMonths;
